import { FC } from "react";
import { Box, Button, CardNotification, Heading, Text } from "@foris/avocado-suite";
import { useAsyncAction } from "@common/hooks/useAsyncAction";
import { downloadBlob } from "@utils/downloadBlob";
import {
  buildCatalogWorkbook,
  CATALOG_FILE_NAME,
  type CatalogStats,
  type LocalesByCode,
} from "@utils/i18nCatalog";
import StatList from "../stat-list";
import { XLSX_MIME } from "../../constants";
import styles from "../../i18nCatalog.module.scss";

const ERROR_MESSAGE = "No se pudo generar el catálogo. El detalle está en la consola.";

interface GenerateCatalogSectionProps {
  locales: LocalesByCode;
  stats: CatalogStats;
}

/** Builds the workbook from scratch, for a client with no catalog in circulation yet. */
const GenerateCatalogSection: FC<GenerateCatalogSectionProps> = ({ locales, stats }) => {
  const { run, isLoading, error } = useAsyncAction(async () => {
    const { workbook } = await buildCatalogWorkbook(locales);
    const buffer = await workbook.xlsx.writeBuffer();

    downloadBlob(new Blob([buffer], { type: XLSX_MIME }), CATALOG_FILE_NAME);

    return null;
  }, ERROR_MESSAGE);

  return (
    <Box className={styles.i18nCatalog_card}>
      <div className={styles.i18nCatalog_cardHeader}>
        <Heading type="h3">Generar un catálogo desde cero</Heading>
        <Text type="sm">
          Crea el Excel de cero con los textos actuales de la app. Solo si todavía no hay ningún
          catálogo en circulación.
        </Text>
      </div>

      <StatList
        items={[
          { label: "textos", value: stats.totalKeys },
          { label: "pestañas", value: stats.sheetsCount },
          { label: "con variables", value: stats.varsCount },
        ]}
      />

      <div className={styles.i18nCatalog_actions}>
        <Button leftIcon="download" loading={isLoading} onClick={() => run()} variant="secondary">
          Descargar catálogo vacío
        </Button>
      </div>

      {!!error && (
        <CardNotification state="error" title="Error" outlined>
          <Text type="sm">{error}</Text>
        </CardNotification>
      )}
    </Box>
  );
};

export default GenerateCatalogSection;
